module.exports = __webpack_public_path__ + "franchise-steep-desktop.png";